module.exports = __webpack_public_path__ + "625c8fd8e178342df3e4dcc13605517e.png";